<div class="title-panel">
    Transformação de Dados
</div>
<mat-divider></mat-divider>
<div class="info">
    Etapa para tratar o retorno do Response de uma etapa específica e persistir na TemAPI
</div>

<mat-divider></mat-divider>

<div class="main-ddt">

    <div class="more-options-offSet">
        <div class='more-options-offSet-row'>
            <div class="more-options-offset-column">
                <mat-slide-toggle  matTooltip="Usar Nova Busca de XML, com XPath nativo." matTooltipClass="toolTip-request" [(ngModel)]="usaNewXml"  [ngModelOptions]="{standalone: true}">Usar Novo XML
                </mat-slide-toggle>
            </div>
            <div class="more-options-offset-column">
                <mat-slide-toggle  matTooltip="Usar Procedure para Transformação de Dados" matTooltipClass="toolTip-request" [(ngModel)]="usaProcedureRetorno" (change)="onToggleChange('usaProcedureRetorno')" [ngModelOptions]="{standalone: true}">Usar Procedure
                </mat-slide-toggle>
            </div>
            <div class="more-options-offset-column">
                <mat-slide-toggle  matTooltip="Ao habilitar essa opção, na transformação de dados realiza requisições configuráveis" matTooltipClass="toolTip-request" [(ngModel)]="hasDetails"  (change)="onToggleChange('hasDetails')" [ngModelOptions]="{standalone: true}" [disabled]="showProcedure">Usar Detalhes
                </mat-slide-toggle>
            </div>
        </div>
        <div class='more-options-offSet-row'>
            <div class="more-options-offset-column">
                <mat-slide-toggle  matTooltip="Usar Split de Dados das Informações" matTooltipClass="toolTip-request" [(ngModel)]="usaSplit"  (change)="onToggleChange('usaSplit')" [ngModelOptions]="{standalone: true}" [disabled]="showProcedure">Dividir Dados
                </mat-slide-toggle>
            </div>
            <div class="more-options-offset-column">
                <mat-slide-toggle  matTooltip="Configurar múltiplas persistências de dados" matTooltipClass="toolTip-request" [(ngModel)]="usaChild"  (change)="onToggleChange('usaChild')" [ngModelOptions]="{standalone: true}" [disabled]="showProcedure">Múltipla Perstência
                </mat-slide-toggle>
            </div>
            <div class="more-options-offset-column">
                <mat-slide-toggle  matTooltip="Persistir dados mesmo com erro no retorno" matTooltipClass="toolTip-request" [(ngModel)]="executeStatusError" (change)="onToggleChange('executeStatusError')"  [ngModelOptions]="{standalone: true}">Persiste Com Erro
                </mat-slide-toggle>
            </div>
        </div>
    </div>

    <expanse-panel title="Busca de Dados" [open]="true">
        <mat-form-field [formGroup]="firstFormGroup"  class="no-padding-form-field-5px full-width">
            <mat-label>Tipo de Objeto Para Processamento</mat-label>
            <mat-select formControlName="type" (selectionChange)="changeTipoProc($event)">
            <mat-option *ngFor="let item of typeObjectCode" [value]="item.type">
                {{item.name}}
            </mat-option>
            </mat-select>
        </mat-form-field>
    
        <mat-form-field [formGroup]="firstFormGroup"  appearance="outline" class="no-padding-form-field-5px full-width" *ngIf="showOrigem">
            <mat-label>Caminho do Objeto</mat-label>
            <input  tabindex="1" type = "text" matInput formControlName="origem" placeholder="Caminho da Origem do Dados"  #inporigem matTooltip="Informar o Caminho do Objeto que será processado." matTooltipClass="toolTip-request"> 
            <button    tabindex="-1"  type="button" *ngIf="inporigem.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inporigem.value=''" >
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field [formGroup]="firstFormGroup"  appearance="outline" class="no-padding-form-field-5px full-width" *ngIf="showExtendedPath" matTooltip="Ao escolher o tipo de Objeto com OBJETO, não informar valor nesse campo se informação processada é root." [matTooltipDisabled]="firstFormGroup.get('type').value!='object'" matTooltipClass="toolTip-request">
            <mat-label>Busca de Caminho do Objeto Complexa</mat-label>
            <input  tabindex="1" type = "text" matInput formControlName="origemPath" placeholder="Caminho da Origem do Dados Complexa"  #inporigemPath matTooltip="Informar o Caminho do Objeto que será processado, busca complexa." matTooltipClass="toolTip-request"> 
            <button    tabindex="-1"  type="button" *ngIf="inporigemPath.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inporigemPath.value=''" >
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>

        <mat-form-field [formGroup]="firstFormGroup"  class="no-padding-form-field-5px full-width" >
            <mat-label>Etapa para Processar o Retorno</mat-label>
            <mat-select formControlName="orderData" >
            <mat-option *ngFor="let item of orderDataList|async" [value]="item.EXECORDER">
                {{item.EXECORDER}} - {{item.NAME}}
            </mat-option>
            </mat-select>
        </mat-form-field>
    </expanse-panel>

    <expanse-panel title="Inf. de Persistência de Dados" [open]="true" [hidden]="!showProcedure">
        <mat-form-field [formGroup]="firstFormGroup"  class="no-padding-form-field-5px full-width" >
            <mat-label>Nome do Procedimento</mat-label>
            <mat-select formControlName="procedure" >
            <mat-option *ngFor="let item of procedureList | async" [value]="item['OBJECTNAME']">
                {{item['OBJECTNAME']}}
            </mat-option>
            </mat-select>
        </mat-form-field>
    </expanse-panel>
    <expanse-panel title="Info de Persistência de Dados" [open]="true" [hidden]="showProcedure">
        <search-input  [loaddesc]="true" ignoreDefCondition="false" entityname="Mktpdic" [form]="firstFormGroup"  [condition]="conditionSearch" entitydesc="Tabela de Entidades" controlname="destino" placeholder="Tabela" fieldname="INSTANCENAME" columnname="IDINSTANCE" class="no-padding-form-field-5px" >
        </search-input>
        
        <mat-form-field  [formGroup]="dataFormGroup"   class="no-padding-form-field-5px full-width">
            <mat-label>Tipo de Persistência</mat-label>
            <mat-select formControlName="operacao" (selectionChange)="changeOperation($event)">
                <mat-option *ngFor="let item of operationCodes" [value]="item.operation">
                    {{item.name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        
        <mat-form-field [formGroup]="dataFormGroup"  appearance="outline" class="no-padding-form-field-5px full-width" [hidden]="!showCondition" >
            <mat-label>Condição para Busca de Dados</mat-label>
            <input  tabindex="1" type = "text" matInput formControlName="condicao" placeholder="Condição para busca de dados ( Ex: campo1 = 'a' and campo2 ='b')"  #inpcondicao matTooltip="Indicar a condição para busca de dados para alteração" matTooltipClass="toolTip-request"> 
            <button    tabindex="-1"  type="button" *ngIf="inpcondicao.value" matSuffix mat-icon-button aria-label="Clear"  (click)="inpcondicao.value=''" >
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </expanse-panel>
</div>